module.exports = __webpack_public_path__ + "img/dsci0094.31ac57e0.jpg";